function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.125 0C3.64502 0 0 3.64502 0 8.125C0 12.605 3.64502 16.25 8.125 16.25C12.605 16.25 16.25 12.605 16.25 8.125C16.25 3.64502 12.605 0 8.125 0ZM8.125 1.25C11.9287 1.25 15 4.32129 15 8.125C15 11.9287 11.9287 15 8.125 15C4.32129 15 1.25 11.9287 1.25 8.125C1.25 4.32129 4.32129 1.25 8.125 1.25ZM8.125 3.125C6.40625 3.125 5 4.53125 5 6.25C5 7.19727 5.44189 8.03955 6.11328 8.61328C4.70703 9.34326 3.75 10.813 3.75 12.5H5C5 10.7666 6.3916 9.375 8.125 9.375C9.8584 9.375 11.25 10.7666 11.25 12.5H12.5C12.5 10.813 11.543 9.34326 10.1367 8.61328C10.8081 8.03955 11.25 7.19727 11.25 6.25C11.25 4.53125 9.84375 3.125 8.125 3.125ZM8.125 4.375C9.16748 4.375 10 5.20752 10 6.25C10 7.29248 9.16748 8.125 8.125 8.125C7.08252 8.125 6.25 7.29248 6.25 6.25C6.25 5.20752 7.08252 4.375 8.125 4.375Z",
  fill: "#666666"
});

function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.e25f8af2897e85fd9df047774e33dd52.svg";
export { ForwardRef as ReactComponent };